module.exports = __webpack_public_path__ + "img/12.e7872ea0.png";